import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource, PageEvent } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { ComentarioDialogComponent } from '../comentario-dialog/comentario-dialog.component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-bitacora-dialog',
  templateUrl: './bitacora-dialog.component.html',
  styleUrls: ['./bitacora-dialog.component.scss']
})
export class BitacoraDialogComponent implements OnInit {

  cita: any;
  idcita: number;
  loading: boolean = false;

  // Mapa de colores por tipo - agregar nuevos tipos aqui
  tipoColores: { [key: string]: string } = {
    'Gestion': '#1565c0',
    'Plantilla': '#2e7d32',
    'Cita': '#e65100',
    'Comentario': '#4a148c',
  };
  tipoColorDefault: string = '#757575';

  displayedColumns: string[] = [
    'tipo', 'orden', 'tipologia', 'subtipologia', 'fecha',
    'fecha_visita', 'am_pm', 'estado', 'contrata',
    'tecnico', 'prioridad', 'direccion', 'localizacion'
  ];
  dataSource = new MatTableDataSource<any>([]);
  totalRegistros: number = 0;
  paginaActual: number = 1;
  pageSize: number = 10;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public dialogRef: MatDialogRef<BitacoraDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gateway: GatewayService,
    private dialog: MatDialog
  ) {
    this.cita = data.cita;
    this.idcita = data.cita.idcita || data.cita.id;
  }

  ngOnInit() {
    this.cargarBitacora(1);
  }

  cargarBitacora(pagina: number): void {
    this.loading = true;
    this.paginaActual = pagina;
    this.gateway.get('obtenerbitacora', {
      IDCITA: this.idcita,
      PAGINA: pagina
    }).then((res: any) => {
      this.dataSource.data = res.rows || [];
      this.totalRegistros = res.total || 0;
      this.loading = false;
    }).catch(err => {
      // Error handled silently
      this.loading = false;
    });
  }

  onPageChange(event: PageEvent): void {
    this.cargarBitacora(event.pageIndex + 1);
  }

  getBadgeColor(tipo: string): string {
    return this.tipoColores[tipo] || this.tipoColorDefault;
  }

  abrirComentarioDialog(): void {
    const dialogRef = this.dialog.open(ComentarioDialogComponent, {
      width: '500px',
      panelClass: 'bitacora-dialog-panel',
      disableClose: true,
      data: { idcita: this.idcita }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cargarBitacora(1);
      }
    });
  }

  formatFecha(fecha: any): string {
    if (!fecha) return '';
    const str = String(fecha);
    if (str.indexOf('->') > -1) return str;
    const d = new Date(str);
    if (isNaN(d.getTime())) return str;
    const dd = ('0' + d.getDate()).slice(-2);
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const yyyy = d.getFullYear();
    const hh = ('0' + d.getHours()).slice(-2);
    const min = ('0' + d.getMinutes()).slice(-2);
    return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
  }

  descargar(): void {
    const totalPaginas = Math.ceil(this.totalRegistros / this.pageSize);
    const promesas = [];
    for (let i = 1; i <= totalPaginas; i++) {
      promesas.push(this.gateway.get('obtenerbitacora', {
        IDCITA: this.idcita,
        PAGINA: i
      }));
    }

    Promise.all(promesas).then((resultados: any[]) => {
      let todos = [];
      resultados.forEach(res => {
        if (res.rows) todos = todos.concat(res.rows);
      });

      const data = todos.map(r => ({
        'Tipo': r.tipo || '',
        'Orden': r.orden || '',
        'Tipología': r.tipologia || '',
        'Subtipología': r.subtipologia || '',
        'Fecha': this.formatFecha(r.fecha),
        'Fecha Visita': r.fecha_visita || '',
        'AM/PM': r.am_pm || '',
        'Estado/Comentario': r.estado || '',
        'Contrata': r.contrata || '',
        'Técnico': r.tecnico || '',
        'Prioridad': r.prioridad || '',
        'Dirección': r.direccion || '',
        'Localización': r.localizacion || ''
      }));

      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Bitácora');
      const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const orden = todos.length > 0 ? todos[0].orden || '' : '';
      saveAs(new Blob([buf], { type: 'application/octet-stream' }), `Bitacora_${orden}.xlsx`);
    });
  }

  isCoords(val: string): boolean {
    if (!val) return false;
    return /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/.test(val.trim());
  }

  getMapsUrl(coords: string): string {
    const c = coords.trim();
    return `https://www.google.com/maps?q=${c}`;
  }

  cerrar(): void {
    this.dialogRef.close();
  }
}
